// extracted by mini-css-extract-plugin
export default {"FeeEarnerBulkUpdate":"styles_FeeEarnerBulkUpdate__5O-7C","assignButton":"styles_assignButton__Ub6wr","selectFeeEarners":"styles_selectFeeEarners__OgOOM"};